<template>
  <div>
    <Header @toggle-sidebar="sidebarVisible = !sidebarVisible" />
    <div class="col-12">

      <div class="flex-grow-1 ms-3 me-3 pt-3" style="position: relative;">
        <h2>Welcome to Procricket admin panel </h2>
        <p>Number of active sessions: {{ this.activeSessions }}</p>
        <p>Number of unique user Id's: {{ this.uniqueUserIds }}</p>
        <a role="button" class="procricket-btn mb-3" @click="clearSessions">Clear active sessions</a>
        <br> <br>

        <div class="start-of-page">
          <label>Search for user profile by email:</label>
          <Multiselect v-model="searchEmail" placeholder="Search by email..." :searchable="true" :options="fetchSuggestions" :delay="200" :min-chars="2" :resolve-on-load="false" style="width: 300px" @select="onSelect" @deselect="onSelect" />
        </div>
        <br> <br>
        <br> <br>
        <h4>Cache management</h4>
        <div class="button-container d-flex flex-column flex-sm-row align-items-start">
          <a role="button" class="procricket-btn me-0 me-sm-3 mb-2 mb-sm-0" @click="clearStaticCache">
            Clear static cache
          </a>
          <a role="button" class="procricket-btn me-0 me-sm-3 mb-2 mb-sm-0" @click="clearUsersCache">
            Clear users cache
          </a>
        </div>

        <div v-if="message.length" class="alert-success mt-3 pe-3 text-success">
          {{ message }}
        </div>
        <br>
        <h4>Export emails for campaigns</h4>
        <div class="button-container d-flex flex-column flex-sm-row align-items-start">
          <a role="button" class="procricket-btn mb-3 fixed" @click="showEmailModal=true">
            Export emails to CSV
          </a>
        </div>
        <h4 class="mb-3 mt-2">Go to Events for editing streams</h4>
        <router-link :to="{ name: 'Events'}" class="procricket-btn">
          Events
        </router-link>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal d-block" v-if="showEmailModal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title fw-bold">Export emails for campaigns</h4>
            <button role="button" class="close close-modal" data-dismiss="modal" aria-label="Close" @click="closeSearch">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="modal-form">
              <div class="dropdown">
                <a role="button" class="dropbtn1 procricket-btn mb-3" @click="isDropdownOpen=!isDropdownOpen">{{ searchFilters.typeUser || 'Select Status' }}</a>
                <div class="dropdown-content" :class="{ 'show': isDropdownOpen }">
                  <a href="#" v-for="option in statusOptions" :key="option" @click.prevent="selectOption(option)">{{ option }}</a>
                </div>
              </div>
              <br>
              <div v-if="searchFilters.typeUser === 'TRIAL'" class="dropdown">
                <p>Months for recent session activity:</p>
                <a role="button" class="dropbtn2 procricket-btn mb-3" @click="isDropdownForMontsOpen=!isDropdownForMontsOpen">{{ searchFilters.monthsAgo || 'Select value' }}</a>
                <div class="dropdown-content" :class="{ 'show': isDropdownForMontsOpen }">
                  <a href="#" v-for="option in monthsOptions" :key="option" @click.prevent="selectMonthOption(option)">{{ option }}</a>
                </div>
              </div>
              <br>
              <label>Time range:</label>
              <div class="d-flex">
                <input type="text" v-model="searchFilters.startDate" placeholder="YYYY-MM-DD" class="flex-grow-1 me-2">
                <input type="text" v-model="searchFilters.endDate" placeholder="YYYY-MM-DD" class="flex-grow-1 ms-2">
              </div>
              <br>
            </form>
            <div v-if="modalMessage.length" class="alert-success mt-3 pe-3 text-success">{{ modalMessage }}</div>
            <div v-if="modalError.length" class="error-message mt-3 pe-3">{{modalError}}</div>
          </div>
          <div class="modal-footer">
            <a class="btn cancel-btn" role="button" data-dismiss="modal" @click="closeSearch">Cancel</a>
            <a class="btn signout-popup text-white" role="button" @click="doLoadEmails">Download</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import AdminService from "@/services/admin-service";
import router from "@/router";
import Multiselect from "@vueform/multiselect";
import CacheService from "@/services/cache-service";
import {EmailRequest} from "@/model/models";
import AuthService from "@/services/auth-service";

export default defineComponent({
  components: {
    Header,
    Multiselect
  },
  data () {
    return {
      searchFilters: new EmailRequest(null, null,null, null),
      showEmailModal: false,
      isDropdownOpen: false,
      isDropdownForMontsOpen: false,
      statusOptions: ['PAID', 'TRIAL', 'RENEW'],
      monthsOptions: [1, 3, 6, 12],
      modalError: "",
      modalMessage: "",
      activeSessions: 0,
      uniqueUserIds: 0,
      searchEmail: "",
      error: "",
      message: ""
    }
  },
  created() {
    this.getNumberOfActiveSessions();
  },
  methods: {
    async fetchSuggestions(query) {
      return await AdminService.suggestUsers(query);
    },
    getNumberOfActiveSessions() {
      AdminService.getNumberOfActiveSessions().then((data) => {
        this.activeSessions = data.liveViewers;
        this.uniqueUserIds = data.uniqueIds;
      }).catch((error) => {
        console.log(error)
      });
    },
    clearSessions() {
      AdminService.clearActiveSessions().then(() => {
        this.getNumberOfActiveSessions()
      }).catch((error) => {
        console.log(error)
      });
    },
    onSelect() {
      if (this.searchEmail) {
        router.push({name: 'UserProfile', params: {email: this.searchEmail},});
      }
    },
    clearStaticCache() {
      CacheService.clearStaticCache().then((statusResponse) => {
        this.message = statusResponse.message
        setTimeout(() => {
          this.message = "";
        }, 5000);
      }).catch((error) => {
        console.log(error)
      });
    },
    clearUsersCache() {
      CacheService.clearUsersCache().then((statusResponse) => {
        this.message = statusResponse.message
        setTimeout(() => {
          this.message = "";
        }, 5000);
      }).catch((error) => {
        console.log(error)
      });
    },
    closeSearch() {
      this.showEmailModal = false;
      this.modalMessage = "";
      this.modalError = "";
      this.searchFilters = new EmailRequest(null, null, null)
    },
    selectOption(option) {
      this.searchFilters.typeUser = option;
      this.isDropdownOpen = false;
    },
    selectMonthOption(option) {
      this.searchFilters.monthsAgo = option;
      this.isDropdownForMontsOpen = false;
    },
    closeDropdown(event) {
      if (!event.target.matches('.dropbtn1')) {
        this.isDropdownOpen = false;
      }
      if (!event.target.matches('.dropbtn2')) {
        this.isDropdownForMontsOpen = false;
      }
    },
    doLoadEmails() {
      if (this.searchFilters.typeUser && this.searchFilters.startDate && this.searchFilters.endDate) {
        this.modalError = "";
        let emailFilter = new EmailRequest(this.searchFilters.typeUser, this.searchFilters.monthsAgo, this.dateToUnixTimestamp(this.searchFilters.startDate), this.dateToUnixTimestamp(this.searchFilters.endDate))
        // Check if either startDate or endDate is null, return early if true
        if (emailFilter.startDate === undefined || emailFilter.endDate === undefined) return;
        this.modalMessage = "Loading...";
        AdminService.getEmailListForCampaigns(emailFilter).then(() => {
          this.closeSearch()
        }).catch((error) => {
          this.modalMessage = "";
          this.modalError = error.message;
        });
      } else {
        this.modalError = "All fields are required.";
      }
    },
    // goToEvents(){
    //
    // },
    dateToUnixTimestamp(dateString) {
      // Regular expression to check if the date string matches the format YYYY-MM-DD
      const regex = /^\d{4}-\d{2}-\d{2}$/;

      if (dateString !== undefined && dateString !== null) {
        if (regex.test(dateString)) {
          const date = new Date(dateString);
          return date.getTime();
        } else {
          this.modalError = "Invalid date format. Please use YYYY-MM-DD.";
          return null;
        }
      } else {
        return null;
      }
    },
    doSignOut () {
      AuthService.signOut().then(() => {
        this.$router.push('/signin')
      })
    },
  },
  beforeMount() {
    if (!localStorage.getItem('applicationList')) {
      this.doSignOut()
    }
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeDropdown);
  }
})
</script>

<style src="../assets/style.css">
</style>
